import React, { useState } from 'react';

import TranslateBtn from '../TranslateBtn/TranslateBtn';
import style from './style.module.scss';

interface IProps {
  title: string;
  originalText: string;
  translatedText: string;
  hasTranslate: boolean;
  isTranslateLoading: boolean;
  toggleIsTranslate: () => void;
  handleOpenLightbox: (event: React.MouseEvent<HTMLElement>) => void;
}

const AiExtraBlock: React.FC<IProps> = ({
  title,
  originalText,
  translatedText,
  hasTranslate,
  isTranslateLoading,
  toggleIsTranslate,
  handleOpenLightbox,
}) => {
  const [isTranslated, setIsTranslated] = useState(false);

  const handleToggleIsTranslate = () => {
    toggleIsTranslate();
    setIsTranslated(!isTranslated);
  };

  return (
    <div className={style.block}>
      <div className={style.blockHead}>
        <div className={style.blockTitle}>{title}</div>
        <TranslateBtn
          isTranslated={isTranslated}
          hasTranslate={hasTranslate}
          isTranslateLoading={isTranslateLoading}
          toggleIsTranslate={handleToggleIsTranslate}
        />
      </div>
      <div className={style.blockContainer}>
        <div
          className={style.infoText}
          dangerouslySetInnerHTML={{ __html: isTranslated && translatedText ? translatedText : originalText }}
          onClick={(event) => handleOpenLightbox(event)}
        />
      </div>
    </div>
  );
};

export default AiExtraBlock;
